import {forEachObj} from "./tools";

const createError = (message, type, props = {}) => {
	const error = Error(message);
	error.type = type;
	error.custom = true;
	forEachObj(props, (x, k) => error[k] = x);
	return error;
};

export const RouteError = (message) => createError(message, "RouteError");
export const PermissionError = (message) => createError(message, "PermissionError");
export const ApiError = (message, display = true, method, call, data) => createError(message, "ApiError", {display, method, call, data});


// WEBPACK FOOTER //
// ./src/lib/errors.js